// extracted by css-extract-rspack-plugin
export default {"paper":"ResourceUtilizationInfoDialog_paper__f+HHN"};